import Vue from 'vue'
import axios from 'axios'
import Qs from 'qs'
import './config'
// import { APIHOST } from '@/utils/config'
import router from '@/router'


var api = {};

/**======== 读取service目录中的接口列表 ========*/
var files = require.context('./service/').keys().filter(item => item.match(/\.js$/));

files.forEach(item => {
    let _obj = require('./service/' + item.replace('./', '')).default;

    /** 默认设置空对象 */
    Object.keys(_obj).forEach(i => {
        if (!api[i]) { api[i] = {} }
        for (let k in _obj[i]) {
            putApi(i, k, _obj[i][k].url, _obj[i][k].method, _obj[i][k].dataFormat, _obj[i][k].isSign);
        }
    })
        
})
/**======== 读取service目录中的接口列表 ========*/

/**
 * [注册接口]
 * @param  {String} key        命名空间
 * @param  {String} name       接口别名
 * @param  {String} url        接口URL
 * @param  {String} method     请求方式
 * @param  {Boolean} isSign    是否需要做签名验证（针对部分敏感开放接口）
 * @param  {String} dataFormat 请求数据格式,默认json格式 (form | json)
 *
 */
function putApi(key, name, url, method = 'post', dataFormat = 'json', isSign = false) {
    /**
     * [往api对象集合添加接口]
     * @param  {Object}   options  [请求参数]
     */
    api[key][name] = (data = {}) => {
        let vue = new Vue();
            
        let { isLoad = true, ..._data } = data;

        let _opts = {
            headers: {}
        };

        /** 根据数据格式(dataFormat)设置请求头 */
        if (dataFormat === 'form' && method !== 'get') {
            _opts.headers['Content-Type'] = 'application/x-www-form-urlencoded';
            _data = Qs.stringify(_data);
        } else {
            _data = {
                base: {
                    reqTime: '',
                    proNo: '1000',
                },
                body: _data
            }
        }

        /** 设置参数 */
        if (method === 'get') {
            _opts.params = _data;
        } else {
            _opts.data = _data;
        }

        if (isLoad) {
            // Vue.prototype.$bus.emit('showLoad');
        }

        return axios(Object.assign({
            url: process.env.VUE_APP_BASEURL + url,
            method
        }, _opts)).then((res) => {
            if (isLoad) {
                // Vue.prototype.$bus.emit('hideLoad');
            }
            if (res.data && res.data.resCode === '0') {
                return res.data;
            } else {
                Vue.prototype.$Message.error(res.data.resMsg || '请求异常');
                return Promise.reject(res);  
            }
        })
        .catch((err) => {
            if (isLoad) {
                // Vue.prototype.$bus.emit('hideLoad');
            }
            return Promise.reject(err);
        })
    }
    
}

export default api;